import UPDATE_BANKTRANSACTION_ACCOUNTINGLINE from "../graphql/bankTransaction/UpdateBankTransactionAccountingLines.gql";
import { createCompany } from "./companyServices";
import { mathFix } from "./mathServices"

export const defaultBankTransactionFilter = {
    selectedAccount: "ALL",
    search: "",
    // showFilterBox: true,
    amount: {
        type: "ALL",
        maximum: "",
        minimum: ""
    },
    date: {
        begin: "",
        end: "",
        format: "YYYY-MM-DD"
    },
    pagination: {
        sortBy: ["dateDebit"],
        descending: [true],
        page: 1,
        rowsPerPage: 10,
        totalItems: 0
    },
    reconciliationStatus: "ALL"
};

export async function updateBankTransactionAccountableAccount(apollo, store, companyId, bankTransactions, data, accountingLine = undefined) {
    debugger
    const promises = []

    let thirdParty = data.thirdParty

    if (thirdParty) {
        if (thirdParty?.type === "company") {
            if (!thirdParty.id && thirdParty.name) {
                thirdParty.id = await createCompany(apollo, thirdParty)
            }
        }
        if (thirdParty?.type === "user") {
            if (!thirdParty.id) {
                debugger
                return
            }
        }
        if (thirdParty?.type === "bank") {
            if (!thirdParty.id) {
                debugger
                return
            }
        }
    } else if (data.thirdPartyCompany) {
        if (!data.thirdPartyCompany.id && data.thirdPartyCompany.name) {
            data.thirdPartyCompany.id = await createCompany(apollo, data.thirdPartyCompany.id)
        }
        if (data.thirdPartyCompany.id) {
            thirdParty = {
                type: "company",
                id: data.thirdPartyCompany.id
            }
        } else {
            debugger
            return
        }
    }  else if (data.user) {
        if (!data.user.id) {
            debugger
            return
            // data.thirdPartyCompany.id = await createCompany(apollo, data.thirdPartyCompany.id)
        }
        if (data.user.id) {
            thirdParty = {
                type: "user",
                id: data.user.id
            }
        } else {
            debugger
            return
        }
    } else if (data.bankAccount) {
        if (!data.bankAccount.id) {
            debugger
            return
            // data.thirdPartyCompany.id = await createCompany(apollo, data.thirdPartyCompany.id)
        }
        if (data.bankAccount.id) {
            thirdParty = {
                type: "bank",
                id: data.bankAccount.id
            }
        } else {
            debugger
            return
        }
    }

    const accountableAccountName = data.accountableAccount.name
    for (const bankTransaction of bankTransactions) {
        // debugger
        const variables: any = {
            id: bankTransaction.id || bankTransaction.object.id,
            accountingLines: [],
        }
        let amountSigned = bankTransaction.amount ? -bankTransaction.amount : mathFix(bankTransaction.debit - bankTransaction.credit)
        if (accountingLine) {
            amountSigned = accountingLine.amountSigned
        }
        if (accountingLine && accountingLine.id) {
            variables.toDeleteAccountingLineIds = [accountingLine.id]
        } else if (bankTransaction.reconciliationStatus && bankTransaction.reconciliationStatus.accountingLines && bankTransaction.reconciliationStatus.accountingLines.length) {
            variables.toDeleteAccountingLineIds = bankTransaction.reconciliationStatus.accountingLines.map(al => (al.id))
        }

        // let notJustifiedAmountSigned = bankTransaction.notJustifiedAmountSigned
        // if (accountingLine) {
        //     if (!accountingLine.id) {
        //         notJustifiedAmountSigned += amountSigned
        //     }
        // } else {
        //     notJustifiedAmountSigned = 0
        // }
        // computeJustifiedNotJustified(bankTransaction.amount, notJustifiedAmountSigned, variables)

        if (accountableAccountName) {
            const accountingLine = {
                // company: { connect: { id: companyId } },
                // wording: bankTransaction.wordingDisplay || bankTransaction.wordingOriginal,
                // date: bankTransaction.dateDebit || getDBFormattedDate(bankTransaction.date),
                amountSigned: amountSigned,
                // amount: Math.abs(amountSigned),
                accountableAccountName,
                thirdPartyCompanyId: undefined,
                userId: undefined,
                bankAccountId: undefined,
                // tags: data.tags?.length ? { connect: data.tags.map(t =>({id:t.id})) }:undefined
                tags: data.tags?.length ? data.tags.map(t =>(t.id)) :undefined
            }
            if (thirdParty) {
                if (thirdParty.type === "company") {
                    accountingLine.thirdPartyCompanyId = thirdParty.id
                } else if (data.thirdParty.type === "user") {
                    accountingLine.userId = thirdParty.id
                } else if (data.thirdParty.type === "bank" || thirdParty.type === "bankAccount") {
                    accountingLine.bankAccountId = thirdParty.id
                }
            }
            variables.accountingLines.push(accountingLine)
        }
        // if (bankTransaction.reconciliationId) {
        //     variables.reconciliation = {delete: true}
        // }
        // if (variables.accountingLines.length) {
        //     for (const al of variables.accountingLines) {
        //         computeDebitCredit(al)
        //     }
        // }

        promises.push(apollo.mutate({
            mutation: UPDATE_BANKTRANSACTION_ACCOUNTINGLINE,
            variables: variables
        }))
    }
    if (promises.length) {
        await Promise.all(promises)
    }
}

export function openBankTransaction(router, currentUser, companyId, bankTransaction) {

    const params: any = {
        companyId: companyId,
        bankTransactionId: bankTransaction.id
    };

    if (params.bankTransactionId) {
        router.push({
            name: "reconciliation/bankTransaction",
            params
        });
    }
    // }
}

export function computeNotJustifiedAmountSigned(bt, accountingLines) {
    let totalAmount = 0
    if (bt.version === undefined || bt.version === null || bt.version <= 1) {
        debugger
        totalAmount = bt.amount
    }
    if (accountingLines && accountingLines.length) {
        for (const al of accountingLines) {
            totalAmount += al.amountSigned
        }
    }
    return totalAmount
}

export function computeJustifiedNotJustified(amount, notJustifiedAmountSigned, data) {

    let notJustified = notJustifiedAmountSigned

    if (Math.abs(notJustified) < 1.e-2) {
        notJustified = 0
    }
    let justifiedAmountSigned = amount - notJustified
    if (Math.abs(justifiedAmountSigned) < 1.e-2) {
        justifiedAmountSigned = 0
    }

    data.notJustifiedAmountSigned = notJustified
    data.justifiedAmountSigned = justifiedAmountSigned
    return data
}
